export default {
  login: {
    welcome: 'Bienvenido de nuevo',
    subtitle: 'Inicia sesión para continuar comprando',
    phonePlaceholder: 'Introduce el número de teléfono',
    passwordPlaceholder: 'Introduce la contraseña',
    showPassword: 'Mostrar',
    hidePassword: 'Ocultar',
    loginButton: 'Iniciar sesión',
    registerButton: 'Registro gratuito',
    title: 'Iniciar sesión',
    subtitle2: 'Compras globales todo en uno para ganar recompensas',
    logging: 'Iniciando sesión...',
    phoneRequired: 'Introduce el número de teléfono',
    passwordRequired: 'Introduce la contraseña',
    loginSuccess: 'Inicio de sesión exitoso',
    loginFailed: 'Error al iniciar sesión',
    loginError: 'Error de inicio de sesión, inténtalo de nuevo más tarde'
  },
  register: {
    title: 'Crear cuenta',
    subtitle: 'Únete a nosotros y comienza tu viaje de comercio',
    username: 'Nombre de usuario',
    phone: 'Número de teléfono',
    loginPassword: 'Contraseña de inicio de sesión',
    transactionPassword: 'Contraseña de transacción',
    invitationCode: 'Código de invitación',
    usernamePlaceholder: 'Introduce el nombre de usuario',
    phonePlaceholder: 'Introduce el número de teléfono',
    loginPasswordPlaceholder: 'Introduce la contraseña de inicio de sesión',
    transactionPasswordPlaceholder: 'Introduce la contraseña de transacción',
    invitationCodePlaceholder: 'Introduce el código de invitación',
    registerButton: 'Registrarse',
    hasAccount: '¿Ya tienes cuenta? Iniciar sesión',
    errorUsername: 'Introduce el nombre de usuario',
    errorPhone: 'Introduce el número de teléfono',
    errorLoginPassword: 'Introduce la contraseña de inicio de sesión',
    errorTransactionPassword: 'Introduce la contraseña de transacción',
    errorInviteCode: 'Introduce el código de invitación',
    registerSuccess: 'Registro exitoso'
  },
  tabbar: {
    home: 'Inicio',
    purchase: 'Historial de pedidos',
    grabbing: 'Pedir',
    kefu: 'Servicio al cliente',
    my: 'Mi'
  },
  home: {
    orderCount: 'Número de pedidos',
    upgradeAmount: 'Recargar y actualizar',
    recharge: 'Recargar',
    withdraw: 'Retirar',
    team: 'Gestión de equipo',
    commission: 'Obtener comisión',
    newProducts: 'Nuevos productos',
    newProductsDesc: 'Los últimos estilos de la nueva temporada y colecciones futuras.',
    buyNow: 'Comprar ahora',
    nowAvailable: 'Disponible ahora',
    nowAvailableDesc: 'Prepárate para la temporada de bodas, empaca para tu próximo viaje y actualiza tu armario sin compromiso. Con nuestro nuevo plan de préstamo, puedes probar las últimas tendencias y mantenerte dentro de tu presupuesto sin suscripción.',
    footerTitle: 'Desigual.com',
    footerFollow: "Síguenos en {'@'}Desigual.com y comparte tus estilos favoritos de Desigual.com!",
    footerShop: 'Navega nuestro catálogo'
  },
  purchase: {
    all: 'Todos',
    pending: 'Pendiente',
    completed: 'Completado',
    frozen: 'Congelado',
    balance: 'Saldo de cuenta',
    orderTime: 'Hora de pedido',
    orderId: 'Número de pedido',
    totalAmount: 'Total del pedido',
    commission: 'Comisión',
    expectedReturn: 'Retorno esperado',
    submitOrder: 'Enviar pedido',
    orderCompleted: 'Pedido completado',
    loading: 'Cargando...',
    noData: 'Sin datos de pedidos',
    noMore: 'No hay más',
    orderSuccess: 'Pedido exitoso',
    orderNumber: 'Número de pedido',
    rating: 'Calificación',
    notSubmit: 'No enviar por ahora',
    submitNow: 'Enviar ahora',
    submitting: 'Enviando...',
    submitFailed: 'Error al enviar',
    grabOrderFailed: 'Error al tomar pedido, inténtalo de nuevo más tarde',
    getOrderInfoFailed: 'Error al obtener detalles del pedido',
    submitOrderFailed: 'Error al enviar, inténtalo de nuevo más tarde'
  },
  common: {
    home: 'Inicio',
    about: 'Acerca de',
    contact: 'Contáctanos',
    purchase: 'Historial de pedidos',
    grabbing: 'Pedir',
    my: 'Mi',
    login: 'Iniciar sesión',
    register: 'Registrarse',
    kefu: 'Servicio al cliente',
    loadDataError: 'Error al cargar datos, inténtalo de nuevo más tarde',
    success: 'Operación exitosa',
    failed: 'Operación fallida',
    submitSuccess: 'Envío exitoso',
    submitFailed: 'Error al enviar',
    submitting: 'Enviando...'
  },
  grabbing: {
    accountAmount: 'Monto de cuenta',
    accountBalance: 'Saldo de cuenta',
    getCommission: 'Obtener comisión',
    ordersGrabbedToday: 'Pedidos tomados hoy',
    orderCount: 'Número de pedidos',
    operationSteps: 'Pasos de operación',
    step1: '1. Haz clic en el botón Iniciar tarea y completa la tarea según las instrucciones',
    step2: '2. Después de completar la tarea, puedes liquidar la comisión al saldo',
    grabOrder: 'Tomar pedido',
    pleaseWait: 'Por favor espera',
    grabSuccess: 'Pedido exitoso',
    grabTime: 'Hora de pedido',
    grabNumber: 'Número de pedido',
    orderTotal: 'Total del pedido',
    commission: 'Comisión',
    expectedReturn: 'Retorno esperado',
    rating: 'Calificación',
    notSubmit: 'No enviar por ahora',
    submitNow: 'Enviar ahora',
    submitting: 'Enviando...'
  },
  kefu: {
    title: 'Servicio al cliente',
    intro: {
      line1: 'Si tienes alguna pregunta o necesitas ayuda,',
      line2: 'contáctanos con el servicio al cliente para resolverla'
    },
    serviceTime: {
      label: 'Horario de servicio',
      text: 'Tu servicio al cliente exclusivo',
      online: 'En línea'
    },
    contact: {
      title: 'Contacto',
      name: 'En línea',
      status: 'Consultar',
      feature1: 'Respuesta inmediata',
      feature2: 'Servicio profesional',
      button: 'Contactar'
    },
    faq: {
      title: 'Preguntas frecuentes',
      rechargeQuestion: '¿Cómo recargar?',
      rechargeAnswer: 'Puedes recargar a través de nuestra pasarela de pago segura. Ve a Mi cuenta > Recargar y sigue las instrucciones.',
      withdrawQuestion: '¿Cómo retirar?',
      withdrawAnswer: 'Los retiros se pueden hacer a través de Mi cuenta > Retirar. Asegúrate de que tu cuenta esté verificada.',
      minRechargeQuestion: '¿Cuál es el monto mínimo de recarga?',
      minRechargeAnswer: 'El monto mínimo de recarga es ${currency}68.',
      withdrawTimeQuestion: '¿Cuánto tiempo tarda un retiro?',
      withdrawTimeAnswer: 'Los retiros generalmente se procesan dentro de 24 horas.',
      securityQuestion: '¿Es segura mi información?',
      securityAnswer: 'Sí, utilizamos tecnología de encriptación estándar de la industria para proteger su información personal y financiera.'
    }
  },
  my: {
    inviteCode: 'Código de invitación',
    copy: 'Copiar',
    copySuccess: 'Copia exitosa',
    copyFailed: 'Error al copiar',
    online: 'En línea',
    accountAmount: 'Monto de cuenta',
    balance: 'Saldo de cuenta',
    accountBalanceTrend: 'Saldo de cuenta',
    todayCommission: 'Comisión de hoy',
    totalCommission: 'Comisión total',
    today: 'Hoy',
    total: 'Total',
    todayOrders: 'Pedidos tomados hoy',
    orderCount: 'Número de pedidos',
    recharge: 'Recargar',
    withdraw: 'Retirar',
    rechargeRecord: 'Historial de recargas',
    withdrawRecord: 'Historial de retiros',
    accountDetails: 'Detalles de cuenta',
    receivingAccount: 'Cuenta de recepción',
    bankAccount: 'Cuenta bancaria',
    bankAccountDesc: 'Cuenta bancaria',
    usdt: 'USDT',
    usdtDesc: 'Dirección USDT',
    connect: 'Conectar',
    teamManagement: 'Gestión de equipo',
    viewTeam: 'Ver equipo',
    changePassword: 'Cambiar contraseña',
    changeWithdrawPassword: 'Cambiar contraseña de retiro',
    passwordSettings: 'Configuración de contraseña',
    logout: 'Cerrar sesión',
    signOut: 'Cerrar sesión',
    version: 'Versión'
  },
  changePasswordPage: {
    currentPassword: 'Contraseña de inicio de sesión actual',
    currentPasswordPlaceholder: 'Introduce la contraseña actual',
    newPassword: 'Nueva contraseña de inicio de sesión',
    newPasswordPlaceholder: 'Introduce la nueva contraseña',
    confirmPassword: 'Confirmar contraseña de inicio de sesión',
    confirmPasswordPlaceholder: 'Confirma la nueva contraseña',
    notice: 'La contraseña de inicio de sesión se usa para acceder a la cuenta. La contraseña debe tener al menos 6 caracteres y contener letras y números para garantizar la seguridad.',
    updateButton: 'Actualizar contraseña de inicio de sesión',
    errorOldPassword: 'Introduce la contraseña actual',
    errorNewPassword: 'Introduce la nueva contraseña',
    errorConfirmPassword: 'Confirma la nueva contraseña',
    errorPasswordMismatch: 'Las contraseñas no coinciden',
    errorPasswordLength: 'La contraseña debe tener al menos 6 caracteres',
    errorPasswordFormat: 'La contraseña debe contener letras y números'
  },
  changeWithdrawPasswordPage: {
    currentPassword: 'Contraseña de retiro actual',
    currentPasswordPlaceholder: 'Introduce la contraseña de retiro actual',
    newPassword: 'Nueva contraseña de retiro',
    newPasswordPlaceholder: 'Introduce la nueva contraseña de retiro',
    confirmPassword: 'Confirmar contraseña de retiro',
    confirmPasswordPlaceholder: 'Confirma la nueva contraseña de retiro',
    notice: 'La contraseña de retiro se usa para operaciones de retiro de fondos. La contraseña debe tener al menos 6 caracteres y contener letras y números para garantizar la seguridad.',
    updateButton: 'Actualizar contraseña de retiro',
    errorOldPassword: 'Introduce la contraseña de retiro actual',
    errorNewPassword: 'Introduce la nueva contraseña de retiro',
    errorConfirmPassword: 'Confirma la nueva contraseña de retiro',
    errorPasswordMismatch: 'Las contraseñas no coinciden',
    errorPasswordLength: 'La contraseña debe tener al menos 6 caracteres',
    errorPasswordFormat: 'La contraseña debe contener letras y números'
  },
  details: {
    loading: 'Cargando...',
    noRecords: 'Sin registros',
    noMore: 'No hay más',
    time: 'Hora',
    type: 'Tipo',
    amount: 'Monto',
    balance: 'Saldo',
    remark: 'Observación',
    type0: 'Otro',
    type1: 'Recarga',
    type2: 'Retiro',
    type3: 'Transacción',
    type4: 'Comisión de pedido',
    type5: 'Comisión de subordinado',
    type8: 'Retiro rechazado'
  },
  rechargeRecord: {
    offline: 'Recarga offline',
    online: 'Recarga online',
    loading: 'Cargando...',
    noRecords: 'Sin registros',
    orderNo: 'Número de pedido',
    rechargeAmount: 'Monto de recarga',
    rechargeTime: 'Hora de recarga',
    payMethod: 'Método de pago',
    rechargeStatus: 'Estado de recarga',
    noMore: 'No hay más',
    statusPending: 'Pendiente de aprobación',
    statusApproved: 'Aprobado',
    statusFailed: 'Error',
    statusEmpty: ''
  },
  withdrawRecord: {
    loading: 'Cargando...',
    noRecords: 'Sin registros',
    orderNo: 'Número de pedido',
    withdrawAmount: 'Monto de retiro',
    withdrawTime: 'Hora de retiro',
    withdrawAddress: 'Dirección de retiro',
    withdrawStatus: 'Estado de retiro',
    noMore: 'No hay más',
    statusPending: 'Procesando',
    statusApproved: 'Exitoso',
    statusFailed: 'Error',
    statusEmpty: ''
  },
  withdraw: {
    title: 'Retirar',
    method: 'Método de retiro',
    methodSubtitle: 'Selecciona tu método de retiro',
    bankInfo: 'Información de cuenta bancaria',
    bankName: 'Banco',
    accountHolder: 'Nombre del titular',
    bankCard: 'Tarjeta bancaria',
    amount: 'Monto de retiro',
    balance: 'Saldo',
    withdrawAll: 'Retirar todo',
    paymentPassword: 'Contraseña de pago',
    passwordPlaceholder: 'Introduce la contraseña de fondos',
    principal: 'Monto principal',
    serviceFee: 'Tarifa de servicio',
    netAmount: 'Monto neto',
    notice: '*Verifica cuidadosamente la información de recepción',
    withdrawButton: 'Retirar',
    walletAddress: 'Dirección de billetera',
    walletAddressSubtitle: 'Introduce la dirección de billetera'
  },
  recharge: {
    title: 'Recargar',
    amount: 'Monto de recarga',
    amountSubtitle: 'Introduce el monto que deseas recargar',
    quickSelect: 'Selección rápida',
    rechargeNow: 'Recargar ahora',
    selectPayment: 'Seleccionar método de pago',
    selectPaymentSubtitle: 'Selecciona tu método de pago preferido',
    cancel: 'Cancelar',
    confirm: 'Confirmar',
    crypto: 'Criptomoneda',
    bank: 'Transferencia bancaria',
    paymentRange: 'Mínimo: {symbol}{minAmount} - Máximo: {symbol}{maxAmount}',
    rechargeFailed: 'Error al recargar',
    paymentInfo: 'Información de pago',
    usercode: 'Dirección USDT',
    uploadScreenshot: 'Por favor sube la captura de pantalla del pago',
    clickToUpload: 'Haz clic para subir captura de pantalla',
    copySuccess: 'Copiado exitosamente',
    copyFailed: 'Error al copiar',
    uploadScreenshotRequired: 'Por favor sube la captura de pantalla del pago',
    submit: 'Enviar',
    submitting: 'Enviando...',
    submitSuccess: 'Enviado exitosamente',
    submitFailed: 'Error al enviar'
  },
  bindUsdt: {
    title: 'Vincular USDT',
    cardTitle: 'Dirección USDT',
    cardSubtitle: 'Introduce tu dirección de billetera USDT',
    walletAddress: 'Dirección de billetera',
    walletAddressPlaceholder: 'Introduce la dirección de billetera USDT',
    networkType: 'Tipo de red',
    networkTypePlaceholder: 'Selecciona el tipo de red',
    withdrawPassword: 'Contraseña de retiro',
    withdrawPasswordPlaceholder: 'Introduce la contraseña de retiro',
    trc20: 'TRC20',
    trc20Network: 'Red TRC20',
    erc20: 'ERC20',
    erc20Network: 'Red ERC20',
    securityNotice: 'Aviso de seguridad',
    securityText1: '• Su dirección USDT está encriptada y almacenada de forma segura',
    securityText2: '• Solo usted puede ver y modificar esta información',
    securityText3: '• Asegúrese de que toda la información sea precisa',
    buttonText: 'Guardar información',
    buttonSubtitle: 'Vincular dirección USDT',
    errorWalletAddress: 'Introduce la dirección de billetera',
    errorNetworkType: 'Selecciona el tipo de red',
    errorWithdrawPassword: 'Introduce la contraseña de retiro'
  },
  team: {
    title: 'Gestión de equipo',
    level1: 'Equipo de nivel 1',
    level2: 'Equipo de nivel 2',
    level3: 'Equipo de nivel 3',
    level1Members: 'Miembros del equipo de nivel 1',
    level2Members: 'Miembros del equipo de nivel 2',
    level3Members: 'Miembros del equipo de nivel 3',
    totalMembers: 'Total de miembros',
    totalCommission: 'Comisión total',
    members: 'personas',
    orders: 'Pedidos',
    commission: 'Comisión',
    noMembers: 'Sin miembros',
    loading: 'Cargando...',
    noMore: 'No hay más'
  },
  bindBank: {
    title: 'Vincular tarjeta bancaria',
    cardTitle: 'Información bancaria',
    cardSubtitle: 'Selecciona tu banco e introduce los detalles de la cuenta',
    bankName: 'Banco',
    bankNamePlaceholder: 'Introduce el nombre del banco',
    cardNumber: 'Número de tarjeta',
    cardNumberPlaceholder: 'Introduce el número de tarjeta',
    realName: 'Nombre real',
    realNamePlaceholder: 'Introduce el nombre real',
    withdrawPassword: 'Contraseña de retiro',
    withdrawPasswordPlaceholder: 'Introduce la contraseña de retiro',
    securityNotice: 'Aviso de seguridad',
    securityText1: '• Su información bancaria está encriptada y almacenada de forma segura',
    securityText2: '• Solo usted puede ver y modificar esta información',
    securityText3: '• Asegúrese de que toda la información sea precisa',
    buttonText: 'Guardar información',
    buttonSubtitle: 'Vincular cuenta bancaria',
    errorBankName: 'Introduce el nombre del banco',
    errorCardNumber: 'Introduce el número de tarjeta',
    errorRealName: 'Introduce el nombre real',
    errorWithdrawPassword: 'Introduce la contraseña de retiro'
  }
}
